import { getUrlSpecifiedParam } from "./util";
import store from "@/store";
import comefromConfig from "./comefromConfig";
import { navigateTo } from "./miniapp";
import { isDingDing } from "./ddMiniapp";

function getEnv() {
  let ENV = "apps";
  const baseUrl = location.href;
  if (/dev\./.test(baseUrl)) {
    ENV = "dev";
  } else if (/test\./.test(baseUrl)) {
    ENV = "test";
  } else if (/apps\.daishutijian\.com/.test(baseUrl)) {
    ENV = "apps";
  }
  return ENV;
}

export function comefromConfigObj() {
  return comefromConfig[getEnv()];
}

export function comefromLink(page) {
  if (!store.state.comefrom || !page) {
    return false;
  }

  console.log(store, store.state.comefrom.type);
  switch (store.state.comefrom.type) {
    case "wx-miniapp":
      // 微信小程序跳转
      navigateTo(store.state.comefrom[page]);
      break;
    case "dd-miniapp":
      // 钉钉小程序跳转
      dd.navigateTo({ url: store.state.comefrom[page] });
      break;
    default:
      // 普通h5跳转
      window.location.replace(store.state.comefrom[page]);
  }
  return true;
}

const signArray = ["isSpecialty", "isInduction"];
(
  // 第三方入口进来的标识
  function() {
    // 获取入口标识，然后存储在store里面
    // let comefrom = getUrlSpecifiedParam('appName') || sessionStorage.getItem("comefrom")
    try {
      let comefrom =
        getUrlSpecifiedParam("comefrom") || sessionStorage.getItem("comefrom");

      if (comefrom === "pocketInfirmarySystem") {
        sessionStorage.setItem("comefrom", comefrom);
        store.commit(
          "SET_COMEFROM",
          comefromConfig[getEnv()][comefrom](isDingDing()) || null
        );
      } else if (comefrom) {
        sessionStorage.setItem("comefrom", comefrom);
        store.commit(
          "SET_COMEFROM",
          comefromConfig[getEnv()][comefrom] || null
        );
      }
      // 存储进来的标示 isSpecialty 专科体检  isInduction入职体检
      signArray.forEach(key => {
        let result = getUrlSpecifiedParam(key) || sessionStorage.getItem(key);
        if (result) {
          sessionStorage.setItem(key, result);
        }
      });
    } catch (error) {}
  }
)();
